import AuthStore from 'stores/Auth';

export default function RefluxMixin(ParentClass) {
  return ParentClass;
  // return class Authorizer extends ParentClass {
  //   static willTransitionTo(transition) {
  //     console.log(AuthStore.isAuthenticated());
  //     if (!AuthStore.isAuthenticated()) {
  //       transition.redirect('/login', {}, {nextPath : transition.path});
  //     }
  //   }
  // };
}



// WEBPACK FOOTER //
// ./src/js/Util/Authorizer.js